import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-size-12-400 ml-3 pb-2" }
const _hoisted_2 = { class: "font-size-16-600" }
const _hoisted_3 = { class: "font-14 font-grey-dark mb-1" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = {
  key: 0,
  class: "font-size-12-600 mt-1"
}

import {getPaymentStatus} from "@/views/OrdersComponents/Helpers";
import {convertDateCalendar} from "@/components/Helpers/DateHelper";
import {computed} from 'vue';
import EventsAndActivityPanelCard
  from "@/components/Layout/LayoutV2/EventsAndActivityPanel/EventsAndActivityPanelCard.vue";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderActivity',
  props: {
  recentActivity: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  setup(__props) {

const router = useRouter();

const props = __props

const getTotalOrderItems = computed(() => {
  if (props.recentActivity.meta.items > 1) {
    return `${props.recentActivity.meta.items} Items` ?? ''
  }

  return `${props.recentActivity.meta.items} Item` ?? ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EventsAndActivityPanelCard, {
    icon: "cart-icon",
    title: "Recent Activity",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'order-view', params: { id: __props.recentActivity.id } })))
  }, {
    customContent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _cache[1] || (_cache[1] = _createTextVNode(" Order ID: ", -1)),
          _createElementVNode("span", _hoisted_2, "#" + _toDisplayString(__props.recentActivity.id), 1)
        ]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(convertDateCalendar)(__props.recentActivity.meta.created_at)), 1),
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode(_toDisplayString(getTotalOrderItems.value) + " ", 1),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "secondary-button-color mr-1" }, "|", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-grey-dark" }, "Status", -1)),
          _cache[4] || (_cache[4] = _createTextVNode(" New ", -1))
        ]),
        (__props.recentActivity.meta.total)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
              _createTextVNode(_toDisplayString(__props.recentActivity.meta.total) + " ", 1),
              _createElementVNode("span", {
                class: _normalizeClass([_unref(getPaymentStatus)(__props.recentActivity.meta).color, "font-size-10-600"])
              }, " (" + _toDisplayString(_unref(getPaymentStatus)(__props.recentActivity.meta).status) + ") ", 3)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})